import { render, staticRenderFns } from "./Enrollments.vue?vue&type=template&id=60cd4105&"
import script from "./Enrollments.vue?vue&type=script&lang=js&"
export * from "./Enrollments.vue?vue&type=script&lang=js&"
import style0 from "./Enrollments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports